<template>

  <b-modal
    ref="bugReportModal"
     id="show-bug-report-modal"
     :cancel-title="$t('Cancel')"
     :ok-title="$t('Send.report')"
     :title="$t('Report.a.bug')"
     cancel-variant="danger"
     @hidden="resetModal"
     @ok="handleOk"
     @show="resetModal">

    <form ref="formReportBug" @submit="handleSubmit">
      <b-form-group
        :invalid-feedback="form.commentaire.invalidFeedback"
        :label="$t('Report.a.bug.label')"
        label-for="reportBug-input">
        <b-form-textarea
          id="reportBug-input"
          :placeholder="$t('Report.a.bug.placeholder')"
          v-model="form.commentaire.value">
        </b-form-textarea>
      </b-form-group>
    </form>

  </b-modal>

</template>

<script>

import api from "../../services/api";
import * as Sentry from "@sentry/vue";

export default {

  name:"ShowBugReportModal",

  data(){
    return{
      form:{
        commentaire:{
          value: null,
          state: null,
          invalidFeedback: null
        }
      },
      feedbackSlack: {
        fallback: `Bug signalé par ${this.$store.getters.username}`,
        color: "#d9534f",
        title: "Yujo\n\n\n\n",     // <------ 4.1 ICI
        title_link: "https://bleu122.sentry.io/projects/yujo/", // <------ 4.1 ICI
        fields: [
          { title: "Utilisateur", value:this.$store.getters.username },
          { title: "Commentaire", value: "ID_unique_du_bug", short: true },
          { title: "ID de l'événement", value: "ID_unique_du_bug", short: true },
          { title: "Environnement", value: process.env.NODE_ENV, short: true }
        ],
        actions: [
          { "type": "button", "text": "Voir l'événement", "url": null }
        ],
        footer: "Sentry",
        ts: new Date().getTime()
      },

    }
  },
  methods: {

    handleOk(bvModalEvt) {
      this.handleSubmit()
    },

    handleSubmit() {
      let eventId = localStorage.getItem('lastEventId')
      if(!eventId){
        localStorage.setItem('lastEventId',null)
        eventId = localStorage.getItem('lastEventId')
      }
      if(eventId && eventId==="null"){
        eventId = Sentry.captureMessage(`feedback ${this.$store.getters.username} at $${new Date().toISOString()}`, 'info');
      }
      const userFeedback = {
        name: this.$store.getters.username,
        email: this.$store.getters.username,
        comments: this.form.commentaire.value,
        event_id:  eventId
      }
      if(eventId){
        this.captureUserFeedback(userFeedback);
        this.sendFeedBackToSlack(eventId)
      }
      this.resetModal()
    },

    captureUserFeedback(feedback){
      const data = JSON.stringify(feedback)
      api.post(`${process.env.SERVER_URL}/sentry/captureUserFeedback`, data, {})
        .then(response => {
          console.log("Merci d'avoir signalé un bug")
        }).catch(err => {
        console.log(err)
      })
    },

    showModal() {
      this.$refs.bugReportModal.show();
    },

    resetModal () {
      this.form.commentaire.value = null
      this.form.commentaire.state = null
      this.form.commentaire.invalidFeedback = null
      this.hideModal()
    },

    hideModal(){
      this.$bvModal.hide('show-bug-report-modal')
    },

    sendFeedBackToSlack(eventId){
      this.feedbackSlack.fields[1].value = this.form.commentaire.value
      this.feedbackSlack.fields[2].value =  eventId
      this.feedbackSlack.actions[0].url =  `https://bleu122.sentry.io/discover/yujo:${eventId}/` // <------ 4.2 ICI

      api.post("https://hooks.slack.com/services/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",{"attachments":[this.feedbackSlack]},{})
      localStorage.setItem("lastEventId",null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/b122/ShowBugReportModal.vue